import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-payment-failure',
    templateUrl: './payment-failure.component.html',
    styleUrls: ['./payment-failure.component.scss'],
    standalone: false
})
export class PaymentFailureComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit(): void {
    window.opener.location.href = '/mycart/payment/failure'
    window.opener.focus()
    window.top.close();
    
    
    
  }

}
